const LEGIT_DEFAULT_URL = 'https://www.amazon.es/gil/es/santander/wait?loanApplicationId=',
  LEGIT_AMAZON_URL = 'www.amazon.es';

export { LEGIT_DEFAULT_URL, LEGIT_AMAZON_URL };
